import React from 'react';
import { AnyType } from '@src/models/common';
import styles from './IndicatorsContainer.module.scss';

/** Непонятно почему начинает ругаться ts если поставить отличный от AnyType тип пропсов */
export const SelectIndicatorsContainer = ({ children }: AnyType) => {
  return (
    <div className={styles.root} data-elem="select-indicator-container">
      {children}
    </div>
  );
};
